import { matchPath } from 'react-router';
import routes from '../consts/routes';
import { IRouteComponentProps } from '../App.d';

const getMatchedRouteParams = (pathname: string): IRouteComponentProps =>
  Object.keys(routes).reduce((carry, id) => {
    const matchedRoute = matchPath<IRouteComponentProps>(pathname, {
      path: routes[id],
      exact: true,
      strict: false,
    });
    if (matchedRoute) {
      return matchedRoute.params;
    }
    return carry;
  }, {});

export default getMatchedRouteParams;
